exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-profile-cars .cars-title {\n  text-align: center;\n  color: #727272;\n  font-size: 20px;\n  padding-top: 24px;\n  padding-bottom: 24px;\n  font-weight: 600; }\n\n.page-profile-cars .cars-list {\n  margin-bottom: 32px; }\n  .page-profile-cars .cars-list .car-item:first-child {\n    border-top: 1px solid #d8d8d8; }\n\n.page-profile-cars .button {\n  margin: 16px auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/ProfileCars/styles.scss
// module id = 1402
// module chunks = 0